'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _MeetingPoint = require('./MeetingPoint.scss');

var _MeetingPoint2 = _interopRequireDefault(_MeetingPoint);

var _reactIntl = require('react-intl');

var _reactGoogleMaps = require('react-google-maps');

var _trip = require('utils/trip');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  MeetingPoint: {
    displayName: 'MeetingPoint'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/MeetingPoint.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var MeetingPoint = _wrapComponent('MeetingPoint')((_dec = (0, _reactCssModules2.default)(_MeetingPoint2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(MeetingPoint, _Component);

  function MeetingPoint(props) {
    (0, _classCallCheck3.default)(this, MeetingPoint);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MeetingPoint.__proto__ || (0, _getPrototypeOf2.default)(MeetingPoint)).call(this, props));

    _this.handleMapClick = _this.handleMapClick.bind(_this);

    if (!(typeof _this.handleMapClick === 'function')) {
      throw new TypeError('Value of "this.handleMapClick" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.handleMapClick));
    }

    _this.fitBounds = _this.fitBounds.bind(_this);

    if (!(typeof _this.fitBounds === 'function')) {
      throw new TypeError('Value of "this.fitBounds" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.fitBounds));
    }

    return _this;
  }

  (0, _createClass3.default)(MeetingPoint, [{
    key: 'handleMapClick',
    value: function handleMapClick() {}
  }, {
    key: 'fitBounds',
    value: function fitBounds() {
      if (!this._googleMapComponent) return;
      var map = this._googleMapComponent;
      var locations = this.props.trip.meeting_points.filter(function (point) {
        return point.location && point.location.lat && point.location.lon;
      }).map(function (point) {
        return new window.google.maps.LatLng(point.location.lat, point.location.lon);
      });
      var bounds = new window.google.maps.LatLngBounds();
      locations.map(function (location) {
        return bounds.extend(location);
      });
      if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
        var extendPoint1 = new window.google.maps.LatLng(bounds.getNorthEast().lat() + 0.001, bounds.getNorthEast().lng() + 0.001);
        var extendPoint2 = new window.google.maps.LatLng(bounds.getNorthEast().lat() - 0.001, bounds.getNorthEast().lng() - 0.001);
        bounds.extend(extendPoint1);
        bounds.extend(extendPoint2);
      }
      map.fitBounds(bounds);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var trip = this.props.trip;

      var hasCustomLocations = trip.custom_locations && trip.custom_locations.length > 0;
      var meetingPoints = (0, _trip.getMeetingPoints)(hasCustomLocations ? trip.custom_locations : trip.meeting_points);
      var markers = hasCustomLocations ? trip.custom_locations.filter(function (loc) {
        return loc.location && loc.location.lat && loc.location.lon;
      }) : trip.meeting_points.filter(function (point) {
        return point.location && point.location.lat && point.location.lon;
      });
      // if (markers.length <= 0) {
      //   return false;
      // }
      return _react3.default.createElement(
        'div',
        { styleName: 'main-container' },
        _react3.default.createElement(
          'div',
          { styleName: 'meeting-point' },
          _react3.default.createElement(
            'h3',
            { styleName: 'header' },
            hasCustomLocations ? _react3.default.createElement(
              'span',
              null,
              'Location'
            ) : _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.meeting_point.label' })
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'meeting-points' },
            meetingPoints.map(function (mp, index) {
              return _react3.default.createElement(
                'div',
                { key: 'mp-' + index, styleName: 'meeting-point-container' },
                !hasCustomLocations && _react3.default.createElement(
                  'div',
                  { styleName: 'meeting-point-label' },
                  mp.icon_name && _react3.default.createElement('i', { styleName: mp.icon_name + '-icon' }),
                  _react3.default.createElement(
                    'span',
                    null,
                    mp.type
                  )
                ),
                _react3.default.createElement(
                  'div',
                  { styleName: 'meeting-point-detail' },
                  mp.text.split(', ').map(function (location, i) {
                    return _react3.default.createElement(
                      'p',
                      { key: 'mp-detail-' + i },
                      '- ',
                      location,
                      _react3.default.createElement('br', null)
                    );
                  }),
                  _react3.default.createElement('br', null)
                )
              );
            })
          )
        ),
        markers.length > 0 && _react3.default.createElement(
          'div',
          { styleName: 'map' },
          _react3.default.createElement(_reactGoogleMaps.GoogleMapLoader, { key: 'AIzaSyDSRKzeQtBsSxJP-lsxOXxajCjaATYMbaw',
            containerElement: _react3.default.createElement('div', {
              // {...this.props}
              style: {
                height: '100%'
              }
            }),
            googleMapElement: _react3.default.createElement(
              _reactGoogleMaps.GoogleMap,
              {
                ref: function ref(map) {
                  _this2._googleMapComponent = map;
                  _this2.fitBounds();
                },
                defaultZoom: 3,
                defaultCenter: { lat: -25.363882, lng: 131.044922 },
                options: { scrollwheel: false },
                onClick: this.handleMapClick
              },
              markers.map(function (marker, index) {
                return _react3.default.createElement(_reactGoogleMaps.Marker, { key: 'marker-' + index, position: { lat: marker.location.lat, lng: marker.location.lon } });
              })
            )
          })
        )
      );
    }
  }]);
  return MeetingPoint;
}(_react2.Component), _class2.propTypes = {
  trip: _react2.PropTypes.object
}, _temp)) || _class));

exports.default = MeetingPoint;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TripDetail/MeetingPoint.js
// module id = 1636
// module chunks = 0